import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { CommonConstants } from "utils/constants";
//#endregion

function useWelcomeGuideHelpers() {
  const welcomeGuideId = CommonConstants.WelcomeGuideId;
  const shownHelps = useSelector((state: AppState) => state.auth.profileToggles.shownHelps);

  const showWelcomeGuide = React.useMemo(
    () => (!shownHelps ? false : !shownHelps.includes(welcomeGuideId)),
    [shownHelps]
  );

  return { showWelcomeGuide };
}

export default useWelcomeGuideHelpers;
